import type { StatusTone } from "@/components/status-badge"

export function contractStatusTone(status?: string | null): StatusTone {
  switch (status) {
    case "DELIVERED":
      return "success"
    case "IN_PROGRESS":
      return "info"
    case "OPEN":
      return "warning"
    case "CANCELLED":
      return "danger"
    default:
      return "muted"
  }
}
